import { StyleSheet } from "react-native-unistyles";

import CustomPlatform from "$src/core/utils/platform/platform";

const stylesheet = StyleSheet.create(({ spacing, border, colors }) => ({
  container: {
    flex: 1,
    bottom: 0,
    paddingBottom: 0,
    // The guide is a wide grid, so it keeps the page gutters but drops the
    // centred max width: more channels fit on a wide screen.
    paddingHorizontal: CustomPlatform.select({
      web: { xs: spacing(4), md: spacing(6), lg: spacing(14) },
      default: { xs: spacing(4), md: spacing(5) },
    }),
  },
  // Figma desktop: 24 between the pill rows, 48 above the columns; the pill rows add 4px each.
  controls: {
    marginBottom: spacing(4),
  },
  channelControls: {
    marginBottom: spacing(11),
  },
  grid: {
    flex: 1,
  },
  overlay: {
    position: "absolute",
    top: 0,
    bottom: 0,
    justifyContent: "center",
    padding: spacing(2),
    zIndex: 1,
  },
  previousOverlay: {
    left: spacing(4),
    variants: {
      canScrollPrev: {
        false: {
          display: "none",
        },
      },
    },
  },
  nextOverlay: {
    right: spacing(8),
    variants: {
      canScrollNext: {
        false: {
          display: "none",
        },
      },
    },
  },
  navButton: {
    borderWidth: border.widths.sm,
    borderColor: colors.borderDefault,
  },
}));

export default stylesheet;
